import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../layout/Navbar';
import { Footer } from '../layout/Footer';
import { Hero } from '../sections/Hero';
import { About } from '../sections/About';
import { Leadership } from '../sections/Leadership';
import { Members } from '../sections/Members';
import { DiasporaCoordinators } from '../sections/DiasporaCoordinators';
import { Events } from '../sections/Events';
import { Join } from '../sections/Join';
import { Button } from '../ui/Button';
import { useStore } from '../store/usestore';

export const Home = () => {
  const { fetchData, hasHydrated } = useStore();

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!hasHydrated) return null;

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
      <Navbar />
      <main>
        <div className="container mx-auto px-4 md:px-6 max-w-7xl pt-28">
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-primary">Take a look at the PBAT profile</h2>
                <p className="text-gray-600 mt-2 max-w-2xl">
                  Read the PBAT profile document to understand the grassroots mobilization plan.
                </p>
              </div>
              <Link to="/profile-pdf">
                <Button variant="primary" size="md">Read PBAT Profile</Button>
              </Link>
            </div>
          </div>
        </div>

        <Hero />
        <About />
        <Leadership />
        <Members />
        <DiasporaCoordinators />
        <Events />
        <Join />
      </main>
      <Footer />
    </div>
  );
};

